import { timeWindowUtils } from '@spotify/confidence-core-react';

import {
  MeasurementConfig,
  getAggregationWindowIfExists,
  getExposureOffsetIfExists,
} from '../../../helpers/time-window';

const toTimeWindowPredicates = (
  measurementConfig: MeasurementConfig | undefined,
): string[] => {
  if (!measurementConfig || measurementConfig.openWindow) {
    return [];
  }

  const exposureOffset = getExposureOffsetIfExists(measurementConfig) ?? '0s';
  const aggregationWindow =
    getAggregationWindowIfExists(measurementConfig) ?? '0s';

  const startOffset = timeWindowUtils.parseWindow(exposureOffset);
  const endOffset = timeWindowUtils.parseWindow(aggregationWindow);

  if (exposureOffset === '0s') {
    return [
      `event_time >= exposure_time`,
      `event_time < exposure_time + INTERVAL '${endOffset}'`,
    ];
  }

  return [
    `event_time >= exposure_time + INTERVAL '${startOffset}'`,
    `event_time < exposure_time + INTERVAL '${startOffset}' + INTERVAL '${endOffset}'`,
  ];
};

export const timeWindowSnippet = (
  measurementConfig: MeasurementConfig | undefined,
): string | undefined => {
  const predicates = toTimeWindowPredicates(measurementConfig);
  if (predicates.length === 0) return undefined;
  return predicates
    .map((p, i) => (i === 0 ? `WHERE ${p}` : `AND ${p}`))
    .join('\n');
};
